<template>
  <div class="screenshots-wrapper">
    <div class="screenshots-wrapper__title">{{ $tr('responses.tabs.test.screenshots.title') }}</div>

    <div v-if="currentScreenshots && currentScreenshots.length" class="screenshots">
      <div class="title">{{ $tr('responses.tabs.test.screenshots.title') }}</div>

      <div v-if="filteredData.length" class="screenshots_content">
        <div v-for="item in filteredData" :key="item.id" class="item">
          <img :src="item.preview_url" />

          <div class="screenshots_content__date">{{ $moment(item.created_at).format('lll') }}</div>
        </div>
      </div>

      <div class="buttons" v-if="showMoreButton || showHideButton">
        <div v-if="showMoreButton" class="button">
          <vbutton :label="$tr('responses.tabs.test.screenshots.more')" @click="count_show += default_count_show" />
        </div>

        <div v-if="showHideButton" class="button">
          <vbutton :label="$tr('responses.tabs.test.screenshots.hide')" @click="count_show = default_count_show" />
        </div>
      </div>

      <div v-if="!filteredData.length" class="no-data">{{ $tr('responses.tabs.test.screenshots.noData') }}</div>
    </div>

    <div v-else-if="isActive" class="no-camera-desc">
      <img src="/static/images/elements/no-camera.svg" />

      <span>{{ $tr('interview.test.passing.noCamera') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResponseScreenshots',

  props: ['screenshots', 'question', 'isActive'],

  data() {
    const default_count_show = 9;
    return {
      default_count_show,
      count_show: default_count_show
    };
  },

  computed: {
    currentScreenshots() {
      if (!this.screenshots || !this.question) {
        return null;
      }

      const screenshotsArray = Object.values(this.screenshots);

      return screenshotsArray.filter(screenshot => {
        if (!screenshot.response_test_question_id) {
          return true;
        }
        return +screenshot.response_test_question_id === +this.question.id;
      });
    },

    filteredData() {
      if (!this.currentScreenshots || !this.currentScreenshots.length) {
        return [];
      }
      return this.currentScreenshots.slice(0, this.count_show);
    },

    showMoreButton() {
      return this.currentScreenshots.length > this.count_show;
    },

    showHideButton() {
      return this.filteredData.length > this.default_count_show
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.screenshots-wrapper {
  padding: 15px 0 10px;

  &__title {
    @include mixin-text-header;
  }
}

.screenshots {
  .title {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
  }
  .screenshots_content {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 7px 0;

    .item {
      flex-basis: calc(calc(100% - 28px) / 3); // 28px - отступ между картинками по 14px
      margin: 7px 14px 7px 0;
      position: relative;

      > img {
        width: 100%;
        vertical-align: middle;
      }
      &:nth-of-type(3n) {
        margin-right: 0;
      }
    }

    &__date {
      position: absolute;
      background: rgba(119, 140, 163, 0.6);
      color: $white;
      font-size: 9px;
      padding: 3px 10px;
      bottom: 0;
      left: 0;
      max-width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .buttons {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: 10px 0;
    .button {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .no-data {
    margin: 10px 0;
    font-size: 15px;
  }
}

.no-camera-desc {
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: #233346;

  img {
    height: 20px;
    margin-right: 9px;
  }
}
</style>
